class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

function lockHeaderMenuPageScroll() {
  if (document.documentElement.classList.contains('yanchi-menu-lock')) return;
  const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  document.documentElement.dataset.yanchiMenuLockedScrollY = String(scrollY);
  document.documentElement.style.setProperty('--yanchi-menu-scroll-y', `${scrollY * -1}px`);
  document.documentElement.classList.add('yanchi-menu-lock');
  document.body.classList.add('yanchi-menu-lock');
}

function unlockHeaderMenuPageScroll() {
  const visualMenuOpen = Boolean(document.querySelector('header-menu details[open] .header__submenu .yanchi-menu-visual'));
  const drawerOpen = Boolean(document.querySelector('header-drawer details[open]'));
  if (visualMenuOpen || drawerOpen) return;

  const scrollY = Number(document.documentElement.dataset.yanchiMenuLockedScrollY || 0);
  document.documentElement.classList.remove('yanchi-menu-lock');
  document.body.classList.remove('yanchi-menu-lock');
  document.documentElement.style.removeProperty('--yanchi-menu-scroll-y');
  delete document.documentElement.dataset.yanchiMenuLockedScrollY;
  window.scrollTo(0, Number.isFinite(scrollY) ? scrollY : 0);
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.content?.querySelector('.yanchi-menu-visual') && window.matchMedia('(min-width: 990px)').matches) {
      this.mainDetailsToggle.open ? lockHeaderMenuPageScroll() : unlockHeaderMenuPageScroll();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
